import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * Simple, lightweight tooltip component for in-app help
 * Usage: <SimpleTooltip content="Your help text here">Hover me</SimpleTooltip>
 */
const SimpleTooltip = ({ content, children, side = 'top', className = '' }) => {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          {children || (
            <button className={`inline-flex items-center justify-center ${className}`}>
              <HelpCircle className="w-4 h-4 text-slate-400 hover:text-slate-600 transition-colors" />
            </button>
          )}
        </TooltipTrigger>
        <TooltipContent 
          side={side}
          className="max-w-xs text-sm bg-slate-900 text-white border-slate-700"
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

/**
 * Info icon with tooltip - for use next to labels
 */
export const InfoTooltip = ({ content, side = 'top' }) => {
  return (
    <SimpleTooltip content={content} side={side}>
      <span className="inline-block ml-1 cursor-help">
        <HelpCircle className="w-3.5 h-3.5 text-slate-400 hover:text-emerald-600 transition-colors" />
      </span>
    </SimpleTooltip>
  );
};

export default SimpleTooltip;
